import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceingurgaon() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Gurgaon',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Gurgaon',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Gurgaon, catering to the transportation needs of IT parks, corporate offices, business centers, and industrial hubs in the region. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Gurgaon.',

    top: 'Top Places to Visit in Gurgaon with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Cyber Hub",
    "description": "Cyber Hub is Gurgaon’s premier dining and entertainment destination, featuring a mix of upscale restaurants, bars, cafes, and live entertainment venues. Located in DLF Cyber City, it attracts young professionals, tourists, and families looking for nightlife, fine dining, and social experiences. The vibrant atmosphere, outdoor seating areas, live music, and seasonal events make it a central hub for entertainment and leisure in Gurgaon."
  },
  {
    "title": "Kingdom of Dreams",
    "description": "Kingdom of Dreams is India’s first live entertainment, theatre, and cultural destination, located in Sector 29, Gurgaon. It showcases Bollywood-style musicals, traditional Indian art forms, and theatrical performances in the impressive Nautanki Mahal. The complex also includes Culture Gully, offering authentic regional cuisine and handicrafts from across India, making it a must-visit for cultural exploration and entertainment."
  },
  {
    "title": "Sultanpur National Park",
    "description": "Sultanpur National Park is a bird sanctuary located on the outskirts of Gurgaon, attracting migratory birds from across the world. Spread over 140 hectares, it is ideal for birdwatchers, nature enthusiasts, photographers, and families seeking a quiet retreat. The park features walking trails, water bodies, and watchtowers, providing visitors with excellent opportunities to observe various bird species in their natural habitat."
  },
  {
    "title": "Ambience Mall",
    "description": "Ambience Mall in Gurgaon is one of India’s largest shopping complexes, offering an extensive range of retail brands, entertainment zones, food courts, and family-friendly activities. It is a favorite destination for shopping, leisure, and weekend outings. The mall regularly hosts events, exhibitions, and cultural performances, making it a vibrant social hub for locals and visitors."
  },
  {
    "title": "Leisure Valley Park",
    "description": "Leisure Valley Park is a beautifully landscaped public park in Gurgaon, featuring lush gardens, jogging tracks, walking paths, fountains, and open-air amphitheaters. It is a popular spot for morning walkers, families, and fitness enthusiasts. Seasonal flower shows, cultural events, and festivals make the park an attractive destination for nature lovers and community gatherings."
  },
  {
    "title": "Aravalli Biodiversity Park",
    "description": "The Aravalli Biodiversity Park is a green oasis in Gurgaon, spread across several hundred acres. It preserves native flora and fauna, hiking trails, and rocky terrains of the Aravalli hills. The park is perfect for trekking, nature walks, photography, and educational trips, providing an ecological escape from the urban sprawl of Gurgaon."
  },
  {
    "title": "Sheetla Mata Mandir",
    "description": "Sheetla Mata Mandir is a revered Hindu temple in Gurgaon dedicated to the goddess Sheetla Mata. Devotees visit the temple for spiritual blessings, especially during festivals like Navratri and Sheetla Ashtami. The temple’s serene atmosphere, religious rituals, and local cultural activities make it an important spiritual landmark in the city."
  },
  {
    "title": "DLF Golf and Country Club",
    "description": "DLF Golf and Country Club is a premium leisure and sports destination in Gurgaon, featuring a world-class 18-hole golf course, tennis courts, and fitness facilities. It attracts golf enthusiasts, corporate events, and social gatherings. The well-manicured greens, scenic landscapes, and exclusive ambiance make it one of Gurgaon’s most prestigious recreational spots."
  },
  {
    "title": "Heritage Transport Museum",
    "description": "The Heritage Transport Museum, located on the outskirts of Gurgaon, is dedicated to the history of transport in India. It showcases vintage vehicles, locomotives, motorcycles, and historic carriages, offering a fascinating glimpse into India’s automotive evolution. The museum is popular among families, enthusiasts, and students interested in history and engineering."
  },
  {
    "title": "MG Road Market and Leisure Area",
    "description": "MG Road is a lively commercial street in Gurgaon featuring shopping outlets, restaurants, cafés, and entertainment venues. It is a bustling area for evening strolls, casual dining, and social hangouts. The street reflects Gurgaon’s urban lifestyle and serves as a popular meeting point for locals and visitors seeking a mix of shopping, leisure, and nightlife."
  }
],


"services": [
{
"name": "Gurgaon Corporate Shuttle",
"description": "Gurgaon Corporate Shuttle provides organized shuttle services for corporate employees, office staff, and industrial workers across Gurgaon. The service features multi-passenger vans, trained drivers, GPS tracking, scheduled pickups, and drop-offs to ensure smooth, safe, and efficient commuting for all employees."
},
{
"name": "Gurugram Employee Transport",
"description": "Gurugram Employee Transport offers structured and reliable daily commute solutions for employees working in corporate offices, IT parks, and industrial units. The service ensures safe travel with trained chauffeurs, GPS-enabled vehicles, multi-shift support, and optimized routes for punctual and hassle-free commuting."
},
{
"name": "Office Pickup Drop Gurgaon",
"description": "Office Pickup Drop Gurgaon provides convenient and dependable employee transport to corporate offices and business locations. The service includes scheduled pickups, professional drivers, GPS tracking, well-maintained sedans and SUVs, and structured routing for a comfortable and timely commute."
},
{
"name": "Company Cab Gurgaon",
"description": "Company Cab Gurgaon delivers professional corporate cab services for employees, executives, and managers. The service ensures trained drivers, GPS-enabled vehicles, punctual pickups, comfortable seating, and reliable operations for daily corporate commuting and office travel."
},
{
"name": "Business Cab Gurgaon",
"description": "Business Cab Gurgaon offers premium corporate taxi services for business travel, client meetings, and executive transport. The service features sedans and SUVs, professional chauffeurs, GPS tracking, and well-coordinated routes to ensure safe, timely, and comfortable business travel."
},
{
"name": "Monthly Corporate Cab Gurgaon",
"description": "Monthly Corporate Cab Gurgaon provides long-term employee transportation solutions for companies requiring consistent daily commutes. The service includes fixed monthly plans, GPS-enabled vehicles, trained drivers, structured routes, and timely pickups and drop-offs for reliable corporate travel."
},
{
"name": "Affordable Corporate Cabs Gurgaon",
"description": "Affordable Corporate Cabs Gurgaon offers budget-friendly employee and corporate transport services without compromising on safety or comfort. The service includes well-maintained sedans and SUVs, professional drivers, GPS monitoring, and optimized routes for cost-effective, reliable commuting."
},
{
"name": "Best Employee Commute Gurgaon",
"description": "Best Employee Commute Gurgaon delivers high-quality transportation services for corporate employees. The service includes trained chauffeurs, GPS-enabled vehicles, structured routing, multi-shift support, and comfortable sedans and SUVs to ensure punctual, safe, and efficient daily commuting."
},
{
"name": "Outstation Cab Gurgaon",
"description": "Outstation Cab Gurgaon provides intercity and long-distance travel solutions for corporate employees, business trips, and industrial visits. The service features GPS tracking, professional drivers, comfortable vehicles, and optimized routes to ensure safe, timely, and stress-free outstation commuting."
},
{
"name": "Sedan Cab Gurgaon",
"description": "Sedan Cab Gurgaon offers premium sedans for executives, managers, and corporate staff. The service includes professional chauffeurs, GPS-enabled vehicles, clean and well-maintained sedans, punctual pickups, and comfortable travel for daily office or business commute."
},
{
"name": "SUV Cab Gurgaon",
"description": "SUV Cab Gurgaon provides spacious and comfortable SUVs suitable for team travel, corporate commuting, and industrial staff transport. The service ensures trained drivers, GPS monitoring, structured routes, and multi-passenger support for safe and efficient transport."
},
{
"name": "Corporate Fleet Gurgaon",
"description": "Corporate Fleet Gurgaon offers fully managed fleet solutions for companies, including sedans, SUVs, and staff cabs. The service covers vehicle maintenance, driver management, GPS tracking, structured routes, and reliable scheduling for organized, efficient, and safe employee commuting."
},
{
"name": "Worker Transport Gurgaon",
"description": "Worker Transport Gurgaon specializes in transporting industrial and factory workers safely and efficiently. The service includes multi-passenger vehicles, trained drivers, structured routes, GPS tracking, and multi-shift support to ensure timely and secure daily commuting."
},
{
"name": "Corporate Mobility Gurgaon",
"description": "Corporate Mobility Gurgaon provides end-to-end employee transportation management for corporate offices and industrial units. The service includes GPS-enabled vehicles, professional drivers, structured scheduling, fleet management, and optimized routing to ensure smooth, reliable, and efficient commuting."
},
{
"name": "Executive Cab Gurgaon",
"description": "Executive Cab Gurgaon delivers premium chauffeur-driven services for executives, managers, and VIP employees. The service features luxury sedans and SUVs, professional drivers, GPS tracking, punctual pickups, and comfortable travel for high-profile corporate commuting."
}
],

"tableData": [
["Gurgaon Corporate Shuttle", "Gurugram Employee Transport"],
["Office Pickup Drop Gurgaon", "Company Cab Gurgaon"],
["Business Cab Gurgaon", "Monthly Corporate Cab Gurgaon"],
["Affordable Corporate Cabs Gurgaon", "Best Employee Commute Gurgaon"],
["Outstation Cab Gurgaon", "Sedan Cab Gurgaon"],
["SUV Cab Gurgaon", "Corporate Fleet Gurgaon"],
["Worker Transport Gurgaon", "Corporate Mobility Gurgaon"],
["Executive Cab Gurgaon", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Gurgaon",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers reliable corporate cab services in Gurgaon, ensuring smooth, timely, and comfortable transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Gurgaon's corporate parks, IT hubs, and commercial zones to help employees reach their destinations without delays."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained and courteous chauffeurs maintain high corporate travel standards, ensuring a safe and comfortable ride for employees and executives."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from our fleet of sedans, SUVs, tempo travellers, and buses—sanitized, serviced, and maintained for reliable corporate commuting."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Solutions",
    "WhyChoosedescription": "We provide tailored cab rental packages designed to meet the specific travel requirements of businesses and employees in Gurgaon."
  },
  {
    "WhyChooseheading": "24/7 Customer & Travel Support",
    "WhyChoosedescription": "Our dedicated support team is available round-the-clock to assist with bookings, emergencies, and travel adjustments, ensuring uninterrupted service."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are routinely sanitized and equipped with essential safety features, offering secure and hygienic rides for corporate travelers."
  },
  {
    "WhyChooseheading": "Seamless Booking & Coordination",
    "WhyChoosedescription": "Corporate transportation is made hassle-free with our easy booking process, efficient coordination, and reliable management systems."
  }
]




























  }

const faqData = [
  {
    question: 'Do you provide corporate cab services in Gurgaon?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers professional and reliable corporate cab services for companies and employees in Gurgaon.',
  },
  {
    question: 'What types of corporate cab services are available in Gurgaon?',
    answer: 'We provide employee transportation, corporate pickups and drops, airport transfers, shuttle services, and dedicated fleet solutions for businesses.',
  },
  {
    question: 'Do you support daily commuting for employees in Gurgaon?',
    answer: 'Yes, we provide optimized daily commute solutions with timely pickups and flexible shift scheduling for corporate offices in Gurgaon.',
  },
  {
    question: 'How can companies book corporate cab services in Gurgaon?',
    answer: 'Bookings can be made through our website, mobile app, or via our 24×7 corporate support team.',
  },
  {
    question: 'What types of vehicles are available for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, luxury cars, Innova Crysta, and tempo travellers based on employee strength and corporate requirements.',
  },
  {
    question: 'Can companies avail long-term corporate cab contracts in Gurgaon?',
    answer: 'Yes, we provide monthly, quarterly, and annual transportation contracts with flexible pricing and transparent terms.',
  },
  {
    question: 'Are safety and tracking features included in corporate cab services?',
    answer: 'All vehicles are GPS-enabled, sanitized regularly, and driven by trained and verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide multi-shift transportation for employees in Gurgaon?',
    answer: 'Yes, we manage transportation for multiple shifts including early morning, evening, night, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services in Gurgaon?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, digital wallets, and provide monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Malhotra',
    feedback: 'Reliable corporate cab service in Gurgaon. Punctual, professional, and safe transportation for our employees.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Sharma',
    feedback: 'Excellent service for corporate transportation in Gurgaon. Smooth operations and professional drivers made commuting hassle-free.',
    rating: 5,
  },
];

































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Gurgaon",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-gurgaon.jpg", // replace with correct image if needed
  "description":
    "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Gurgaon, including employee transport, office pickup & drop, corporate shuttle services, business cabs, monthly corporate cab plans, outstation trips, and executive chauffeur-driven vehicles for companies operating in Gurgaon and Gurugram.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-gurgaon"
  }
};



  return (
    <div>

<Helmet>
  <title>Corporate Cab Service in Gurgaon | Employee & Business Transport</title>

  <meta
    name="description"
    content="Professional corporate cab services in Gurgaon including employee transport, corporate shuttle, office pickup & drop, business cabs, monthly corporate cab plans, outstation trips, and executive chauffeur-driven vehicles for companies in Gurgaon and Gurugram."
  />

  <meta
    name="keywords"
    content="Gurgaon Corporate Shuttle, Gurugram Employee Transport, Office Pickup Drop Gurgaon, Company Cab Gurgaon, Business Cab Gurgaon, Monthly Corporate Cab Gurgaon, Affordable Corporate Cabs Gurgaon, Best Employee Commute Gurgaon, Outstation Cab Gurgaon, Sedan Cab Gurgaon, SUV Cab Gurgaon, Corporate Fleet Gurgaon, Worker Transport Gurgaon, Corporate Mobility Gurgaon, Executive Cab Gurgaon"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/112.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceingurgaon;